<!--
 * @Author: HWD
 * @Date: 2021-10-27 16:00:24
 * @LastEditors: HWD
 * @LastEditTime: 2021-11-12 15:21:40
 * Copyright 2021 © HWD, All Rights Reserved. 
 * @Description: 
-->
<template>
  <div id="app">
    <!--
    <el-carousel :interval="window.interval" arrow="always">
      <template v-if="window.showState">
        <el-carousel-item v-for="(item, index) in window.adpic" :key="index">
          <img :src="item.img" />
        </el-carousel-item>
      </template>
    </el-carousel>
    <qr-code :source="window.source" />
    <template v-if="window.showState">
      <spread-register :source="window.source" />
    </template>
    -->
    <!-- <swiper :source="window.source"/> -->
    <router-view></router-view>
    <!-- <qr-code :source="window.source" />
    <spread-register :source="window.source" /> -->
  </div>
</template>

<script>
// import Swiper from "@/components/Swiper"
// import QrCode from "@/components/QrCode"
// import SpreadRegister from "@/components/SpreadRegister"
//import Spread from '@/components/Spread'
//import Fetch from "./utils/fetch";
export default {
  name: "App",
  components: {
    // Swiper,
    // QrCode,
    //Spread,
    // SpreadRegister
  },
  data() {
    return {
      // window:{
      //   interval:5000,
      //   showState:true,
      //   adpic: [
      //     {
      //       img: "https://img-s-msn-com.akamaized.net/tenant/amp/entityid/AAQ20cO.img?h=412&w=624&m=6&q=60&o=f&l=f&x=408&y=143",
      //     },
      //     {
      //       img: "https://x0.ifengimg.com/ucms/2021_44/F7B09660AB87809070A5D186D796F3E105D8C133_size421_w1080_h602.png",
      //     },
      //   ],
      //   source:''
      // },
   
    };
  },
  created() {
    // this.getUrlObj()
    
    // this.window.source = this.getUrlObj().id
    // this.getData()
  },
  mounted() {},
  updated() {},
  //computed () {},
  methods: {
    getUrlObj() {
      var ret = {};
      console.log(location.search, location);
      var search = location.search.slice(1);
      console.log(search);
      search.replace(/([^?&]+)=([^?&]+)/g, function (s, v, k) {
        ret[v] = decodeURIComponent(k);
        //return k + "=" + v;
      });
      console.log(ret);
      return ret;
    },
    async getData(){
      // console.log(this.window.source)
      // const data = await Fetch("getAdInfo.php", {  });// { CarId: this.window.source }
      // console.log(data);
      // if (data.code == 200) {
      //   this.window.showState = data.data.showAd
      //   this.window.adpic = data.data.adpic;
      // }
    }
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.el-carousel__container {
  height: 10.5rem !important;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 10.5rem !important;
  margin: 0;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}
.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.el-carousel__arrow--left,
.el-carousel__arrow--right {
  display: none;
}

#app .el-carousel .el-carousel__container .el-carousel__item img {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  margin: auto;
  zoom:1;
}
</style>
